<div class="page-wrapper">
  <div class="page-header list-page-header mb-3">
    <h4 class="page-title ">CREATE SUPER AGENT</h4>
  </div>

  <div class="page-content-wrapper">
    <form [formGroup]="form">

      <div class="form-section">
        <h5 class="form-section-heading mb-3">super agent bio data:</h5>
        <div class="body">
          <div class=" row g-3">
            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">FIRST NAME</label>
                <input type="text" placeholder="Enter first name" class="form-control mt-0" formControlName="firstName"
                  maxlength="60" />
                <app-error-message [form]="form" controlName="firstName"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">LAST NAME</label>
                <input type="text" placeholder="Enter last name" class="form-control mt-0" formControlName="lastName"
                  maxlength="60" />
                <app-error-message [form]="form" controlName="lastName"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0">MIDDLE NAME</label>
                <input type="text" placeholder="Enter middle name" class="form-control mt-0"
                  formControlName="middleName" maxlength="60" />
                <app-error-message [form]="form" controlName="middleName"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">PHONE NUMBER</label>
                <input type="text" placeholder="e.g. 09087763552" class="form-control mt-0"
                  formControlName="phoneNumber" maxlength="17" />
                <app-error-message [form]="form" controlName="phoneNumber"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">EMAIL</label>
                <input type="text" placeholder="example@gmail.com" class="form-control mt-0" formControlName="email"
                  maxlength="60" />
                <app-error-message [form]="form" controlName="email"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">STATE</label>
                <input type="text" class="form-control mt-0" value="Anambra" maxlength="100" readonly />

              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">LOCAL GOVT.</label>
                <ng-select [items]="lgaList" [closeOnSelect]="true" [searchable]="true" [hideSelected]="false"
                  bindLabel="name" bindValue="id" placeholder="Select" formControlName="lga" class="ng-select control">
                </ng-select>
                <app-error-message [form]="form" controlName="lga"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>


            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">ZONE</label>
                <ng-select [items]="zoneList" [closeOnSelect]="true" [searchable]="true" [hideSelected]="false"
                  bindLabel="name" bindValue="id" placeholder="Select" formControlName="zone" class="ng-select control">
                </ng-select>
                <app-error-message [form]="form" controlName="zone"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">ADDRESS</label>
                <input type="text" placeholder="1, Onitsha Rd, Onitsha" class="form-control mt-0"
                  formControlName="address" maxlength="120" />
                <app-error-message [form]="form" controlName="address"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="form-section">
        <h5 class="form-section-heading mb-3">OPERATIONAL DETAILS:</h5>
        <div class="body">
          <div class=" row g-3">
            <div class="col-sm-6 col-md-4">
              <div class="action-input-group">
                <label class="mb-0 required">ASIN</label>
                <div class="input">
                  <input type="text" placeholder="e.g. 234545244" appOnlyNumber formControlName="asin" maxlength="20" />
                  <button [disabled]="isVerifyingAsin || form.get('asin').invalid" class="input-action-btn" (click)="verifyAsin();">

                    <ng-container *ngIf="!isVerifyingAsin; else loadingTemplate">
                      <span>Verify</span>
                    </ng-container>
                    <ng-template #loadingTemplate>
                      <span>Verifying...</span>
                    </ng-template>
                  </button>
                </div>
                <app-error-message [form]="form" controlName="asin" [showErrorMessage]="showErrorMessages"
                  label="ASIN"></app-error-message>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">BUSINESS NAME</label>
                <input type="text" placeholder="Enter business name" class="form-control mt-0"
                  formControlName="businessName" maxlength="100" readonly />
                <app-error-message [form]="form" controlName="businessName"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">OPERATING LOCAL GOVT.</label>
                <ng-select [items]="lgaList" [closeOnSelect]="true" [searchable]="true" [hideSelected]="false"
                  bindLabel="name" bindValue="id" placeholder="Select" formControlName="operationLga"
                  class="ng-select control"> </ng-select>
                <app-error-message [form]="form" controlName="operationLga"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">MEAN OF ID</label>
                <ng-select [items]="['National ID Card', 'Driver’s License', 'Voter’s card',
                                            'Nigerian International passport', 'Refugee ID card']"
                  [closeOnSelect]="true" [searchable]="true" [hideSelected]="false" placeholder="Select"
                  formControlName="meansOfId" class="ng-select control role-select">
                </ng-select>
                <app-error-message [form]="form" controlName="meansOfId"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>

            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">ID NUMBER</label>
                <input type="text" placeholder="Enter ID number" class="form-control mt-0" formControlName="idNumber"
                  maxlength="60" />
                <app-error-message [form]="form" controlName="idNumber"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <div class="field">
                <label class="mb-0 required">UPLOAD MEANS OF ID</label>
                <app-upload-input [accept]="'.png, .jpg, .jpeg, .pdf'" [maxFileSize]="1" [isInPreviewMode]="false"
                  (fileChange)="onFileChange($event, 'idUpload')" (error)="onError($event, 'idUpload')" [form]="form"
                  controlName="idUpload"></app-upload-input>

                <app-error-message [form]="form" [maxFileSize]="1" controlName="idUpload"
                  [showErrorMessage]="showErrorMessages"></app-error-message>
              </div>
            </div>
          </div>
        </div>
      </div>


    </form>


    <button class="custom-btn-primary m-auto" (click)="openConfirmModal()" [disabled]="
        !form.dirty || form.invalid || isSubmitting
      ">
      <ng-container *ngIf="!isSubmitting; else loadingTemplate2">
        <span>Create Super Agent</span>
      </ng-container>
      <ng-template #loadingTemplate2>
        <span>Saving Super Agent...</span>
      </ng-template>
      <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.7955 10.6013C9.12344 9.72003 9.18029 8.86723 8.75389 9.26521C8.75389 9.00937 8.78232 8.75353 8.81074 8.49769C9.37928 7.92915 9.8341 7.10478 10.0331 6.13827C10.1184 5.99613 10.2321 5.88243 10.3174 5.51288C10.6585 4.40424 10.2321 4.29053 10.2037 4.2621C10.2889 3.86413 10.4311 2.78392 10.2321 2.18695C9.8341 0.964606 7.64525 0.253938 7.16199 0.140231C6.28076 -0.257743 4.31932 0.794045 3.86449 2.18695C3.66551 2.78392 3.80764 3.8357 3.89292 4.2621C3.46652 4.63165 3.75079 5.62659 4.00663 6.05299C3.80764 6.36568 3.46652 7.07635 3.80764 7.61646C4.00663 7.92915 4.4046 8.07129 4.97314 8.07129C5.08684 8.24185 5.22898 8.38398 5.37111 8.52611C5.39954 8.75353 5.39954 9.00937 5.39954 9.26521C5.28583 9.1515 5.11527 9.1515 5.00156 9.26521C5.00156 9.26521 4.20561 10.0327 2.35788 10.6297C-0.456367 11.6815 0.0268875 15.6044 0.169021 16.4003V16.4287C0.282728 17.0541 0.339581 17.2247 0.510142 17.31C3.46652 18.6176 10.7153 18.6176 13.6433 17.31C13.8423 17.2247 13.8991 17.0541 14.0128 16.4287C14.0128 16.4003 14.0128 16.4003 14.0128 16.3719V16.4003C14.1265 15.5759 14.6382 11.6815 11.7955 10.6013ZM4.4046 2.35751C4.7173 1.44786 6.05335 0.538205 6.76402 0.623485C7.61682 0.765619 9.4077 1.53314 9.69197 2.35751C9.80568 2.72706 9.74883 3.4093 9.69197 3.86413C7.64525 3.66514 6.8493 2.30066 6.82087 2.24381C6.76402 2.15853 6.67874 2.10167 6.56503 2.10167C6.45132 2.10167 6.36604 2.15853 6.30919 2.27223C5.96807 2.95448 5.05842 3.52301 4.37618 3.86413C4.34775 3.38088 4.29089 2.72706 4.4046 2.35751ZM4.26247 7.27534C4.17719 7.16163 4.20562 6.99107 4.26247 6.82051C4.34775 7.04792 4.43303 7.24691 4.54674 7.4459C4.37618 7.38904 4.29089 7.33219 4.26247 7.27534ZM8.18536 8.98094V9.72004C7.38941 10.2317 6.70717 10.2033 5.93964 9.72004C5.93964 9.4642 5.96807 9.23678 5.93964 8.98094C6.67874 9.40734 7.41783 9.43577 8.18536 8.98094ZM13.4443 16.2582C13.3874 16.5709 13.359 16.713 13.3306 16.7699C10.4879 17.9638 3.66551 17.9638 0.822836 16.7699C0.794409 16.713 0.765982 16.5709 0.709129 16.2582V16.2298C0.595422 15.5191 0.140594 12.0226 2.52844 11.1129C3.9782 10.6297 4.831 10.0896 5.17212 9.80532C6.4229 10.914 7.73053 10.914 8.95288 9.80532C9.32242 10.0896 10.1468 10.6297 11.5966 11.1129C14.0128 12.051 13.558 15.5759 13.4443 16.2582Z"
          fill="white" />
      </svg>

    </button>
  </div>


</div>